import { h, Component, Prop, Event, EventEmitter } from "@stencil/core";
import type { ErrorType } from "../types";

const ERROR_MESSAGES: Record<ErrorType, { title: string, description: string }> = {
  "signup": {
    "title": "Sorry, we couldn't create your ArchDaily account at this time.",
    "description": "Please try again later or contact support if the issue continues."
  },
  "login": {
    "title": "Sorry, we couldn't log you in at this time.",
    "description": "Please try again later or contact support if the issue continues."
  },
  "profile_completion": {
    "title": "Sorry, we couldn't complete your profile at this time.",
    "description": "Please try again later or contact support if the issue continues."
  },
  "interests": {
    "title": "Sorry, we couldn't save your interests at this time.",
    "description": "Please try again later or contact support if the issue continues."
  },
  "newsletters": {
    "title": "Sorry, we couldn't save your newsletters at this time.",
    "description": "Please try again later or contact support if the issue continues."
  }
}

@Component({
  tag: 'hd-auth-error',
  shadow: false
})
export class HdAuthError {
  @Prop() errorType: ErrorType = "signup";
  @Event() retryStep: EventEmitter<void>;

  handleRetry = () => {
    this.retryStep.emit();
  }

  render () {
    return (
      <div class="step-container error-container">
        <img src="https://s3.us-east-1.amazonaws.com/assets.adsttc.com/img/auth_error.svg"
          alt="" role="presentation" style={{ minHeight: "97px" }} />
        <div>
          <h3 class="title">{ERROR_MESSAGES[this.errorType].title}</h3>
          <p class="description">{ERROR_MESSAGES[this.errorType].description}</p>
        </div>
        <div class="step-actions grid">
          <button class="next-step" onClick={this.handleRetry}>Retry</button>
          <a class="button prev-step" href="https://www.archdaily.com/contact" target="_blank" rel="noopener noreferrer">
            Contact support
          </a>
        </div>
      </div>
    )
  }
}
